<template>
  <KdsChip tone="persona" :segment="segment">
    <span class="kds-segment-chip__code">{{ code }}</span>
    <span v-if="name" class="kds-segment-chip__sep">·</span>
    <span v-if="name" class="kds-segment-chip__name">{{ name }}</span>
  </KdsChip>
</template>

<script setup lang="ts">
import KdsChip from '@/kds/primitives/KdsChip.vue';
import type { PersonaSegment } from '@/kds/types';

interface Props {
  segment: PersonaSegment;
  code: string;
  name?: string;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.kds-segment-chip {
  &__code {
    font-family: var(--font-mono);
    color: var(--stone);
  }
  &__sep {
    color: var(--stone-2);
    margin: 0 var(--space-1);
  }
  &__name {
    color: var(--ink);
  }
}
</style>
